import {SVGProps} from '@/types';
import React from 'react';

const Pick11 = ({width, height}: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 20}
    height={height || 20}
    viewBox="0 0 20 20"
    fill={'none'}>
    <g clipPath="url(#clip0_1790_13)">
      <path
        d="M10 18.3333C14.6042 18.3333 18.3334 14.6042 18.3334 10C18.3334 5.39584 14.6042 1.66667 10 1.66667C5.39585 1.66667 1.66669 5.39584 1.66669 10C1.66669 14.6042 5.39585 18.3333 10 18.3333Z"
        stroke="black"
        strokeWidth="1.66667"
        strokeMiterlimit="2"
        strokeLinejoin="round"
      />
      <path
        d="M6 3C8.66667 4 15.1 8 17.5 14M2 6.5C4.66667 7.33333 10.5 10.5 13.5 17"
        stroke="black"
        strokeWidth="1.67"
      />
      <path
        d="M6 5.5C7.66667 6.33333 12.5 10 14.5 14"
        stroke="black"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeDasharray="1.8 1.8"
      />
    </g>
    <defs>
      <clipPath id="clip0_1790_13">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Pick11;
